// extracted by mini-css-extract-plugin
export default {"footerUl":"Footer_footerUl__m+OzM"};